(function () {
  'use strict';

  if (window.FlipFitmentTextModal) return;

  var activeModal = null;
  var activeOpener = null;
  var previousBodyOverflow = '';

  function clean(value) {
    return String(value || '').trim();
  }

  function buildMessage(details) {
    var lines = [
      'Hi FLIP - fitment check',
      'Part: ' + clean(details.sku),
    ];
    var machine = [clean(details.brand), clean(details.model)].filter(Boolean).join(' ');

    if (machine) lines.push('Machine: ' + machine);
    if (clean(details.serial)) lines.push('Serial/VIN: ' + clean(details.serial));
    if (clean(details.oem)) lines.push('Stamped/OEM: ' + clean(details.oem));
    lines.push('Photos can follow.');

    return lines.join('\n');
  }

  function buildSmsHref(phoneDigits, message) {
    var digits = clean(phoneDigits).replace(/[^0-9]/g, '');
    var destination = digits.length === 10 ? '+1' + digits : '+' + digits;
    return 'sms:' + destination + '?&body=' + encodeURIComponent(message);
  }

  function track(eventName, modal) {
    if (!window.dataLayer || !Array.isArray(window.dataLayer)) return;
    window.dataLayer.push({
      event: eventName,
      flip_product_sku: modal.dataset.flipFitmentSku || '',
    });
  }

  function formDetails(modal) {
    var form = modal.querySelector('[data-flip-fitment-text-form]');
    return {
      sku: modal.dataset.flipFitmentSku || '',
      brand: form.elements.brand.value,
      model: form.elements.model.value,
      serial: form.elements.serial.value,
      oem: form.elements.oem.value,
    };
  }

  function focusableElements(modal) {
    return Array.prototype.slice.call(modal.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (element) {
      return element.offsetParent !== null;
    });
  }

  function closeModal() {
    if (!activeModal) return;

    activeModal.classList.remove('is-open');
    activeModal.setAttribute('aria-hidden', 'true');
    activeModal.hidden = true;
    document.body.style.overflow = previousBodyOverflow;

    var opener = activeOpener;
    activeModal = null;
    activeOpener = null;

    if (opener && typeof opener.focus === 'function') opener.focus();
  }

  function openModal(trigger) {
    var modalId = trigger.dataset.flipFitmentModalTarget;
    var modal = modalId ? document.getElementById(modalId) : null;
    if (!modal) return false;

    if (activeModal) closeModal();

    activeModal = modal;
    activeOpener = trigger;
    previousBodyOverflow = document.body.style.overflow;

    var fitmentContainer = trigger.closest('[data-flip-fitment]');
    var checkerInput = fitmentContainer
      ? fitmentContainer.querySelector('[data-flip-fitment-input]')
      : null;
    var modelInput = modal.querySelector('[name="model"]');
    var status = modal.querySelector('[data-flip-fitment-text-status]');

    if (checkerInput && clean(checkerInput.value)) modelInput.value = clean(checkerInput.value);
    if (status) status.textContent = '';

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    window.requestAnimationFrame(function () {
      modal.classList.add('is-open');
      modelInput.focus();
    });
    document.body.style.overflow = 'hidden';
    track('flip_fitment_text_modal_open', modal);
    return true;
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }

    return new Promise(function (resolve, reject) {
      var textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();

      try {
        if (document.execCommand('copy')) {
          resolve();
        } else {
          reject(new Error('Copy command was not accepted.'));
        }
      } catch (error) {
        reject(error);
      } finally {
        document.body.removeChild(textarea);
      }
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-flip-fitment-text-trigger]');
    if (trigger && openModal(trigger)) {
      event.preventDefault();
      return;
    }

    if (activeModal && event.target.closest('[data-flip-fitment-modal-close]')) {
      event.preventDefault();
      closeModal();
      return;
    }

    var copyButton = event.target.closest('[data-flip-fitment-copy]');
    if (!activeModal || !copyButton || !activeModal.contains(copyButton)) return;

    var copyModal = activeModal;
    var form = copyModal.querySelector('[data-flip-fitment-text-form]');
    if (!form.reportValidity()) return;

    var message = buildMessage(formDetails(copyModal));
    var status = copyModal.querySelector('[data-flip-fitment-text-status]');
    copyText(message).then(function () {
      if (status) status.textContent = 'Request copied. Paste it into a text to the FLIP team.';
      track('flip_fitment_text_request_copied', copyModal);
    }).catch(function () {
      if (status) status.textContent = 'Copy failed. Select “Open text” instead.';
    });
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-flip-fitment-text-form]');
    if (!form) return;
    event.preventDefault();

    var modal = form.closest('[data-flip-fitment-text-modal]');
    var message = buildMessage(formDetails(modal));
    var href = buildSmsHref(modal.dataset.flipFitmentPhoneDigits, message);
    var status = modal.querySelector('[data-flip-fitment-text-status]');

    if (status) status.textContent = 'Opening Messages. Attach photos there if they help show the fit.';
    track('flip_fitment_text_message_opened', modal);
    window.location.href = href;
  });

  document.addEventListener('keydown', function (event) {
    if (!activeModal) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal();
      return;
    }

    if (event.key !== 'Tab') return;

    var focusable = focusableElements(activeModal);
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  window.FlipFitmentTextModal = {
    buildMessage: buildMessage,
    buildSmsHref: buildSmsHref,
  };
})();
